/**
 * Initialize the modal.
 */
function initModal() {
	jQuery(document).ready(($) => {
		$('.accordion-block .accordion-control').on('click', function () {
			const target = $(this).attr('aria-controls');
			const targetElement = $(`#${target}`);

			if ($(this).attr('aria-expanded') === 'true') {
				$(this).attr('aria-expanded', 'false');
				targetElement.slideUp();
			} else {
				$(this).attr('aria-expanded', 'true');
				targetElement.slideDown();
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initModal();

	if (window.acf) {
		window.acf.addAction('render_block_preview/type=datakaruselli', initModal);
		window.acf.addAction('render_block_preview/type=logokaruselli', initModal);
	}
});
